import type { ReactNode } from "react";

import { TableColumn } from "../table-column";

import styles from "./table-header.module.css";

/**
 * @description A component that renders the table header.
 * It adds an extra column at the beginning and end of the header to create spacing for the scrollbar.
 */
export function TableHeader({ children }: { children: ReactNode }): ReactNode {
	return (
		<>
			<TableColumn className={styles.spacer} isRowHeader />
			{children}
			<TableColumn className={styles.spacer} isRowHeader />
		</>
	);
}
